// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".session-bg {\n  background-color: white;\n  height: 100vh;\n  align-items: center;\n  place-content: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: flex;\n}\n.popup-card {\n  background-color: white;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n}", ""]);
// Exports
module.exports = exports;
